export default "__VITE_ASSET__CiJoy_Qc__"